<template>
  <div>
    <v-flex xs12>
      <h2 class="text-center mb-3">Forsikring</h2>
    </v-flex>
    <v-flex xs12 class="mb-2">
      <v-layout justify-center>
      <v-card flat style="max-width: 500px;">
        
        <v-card-text>
          <v-container fluid class="text-center">
            <img
              src="https://res.cloudinary.com/presis-utleie/image/upload/v1611690064/logo/51c9e935-94ce-4344-81ea-4480e5e079c7.png"
              style="width: 100px; height: auto"
            />
            <h4 class="mt-3 text-center">
              If gjør det enkelt for deg å velge vår beste innboforsikring!
            </h4>
            <img
              src="https://res.cloudinary.com/presis-utleie/image/upload/v1611724476/logo/if_illustration.png"
              style="max-width: 100%"
            />
          </v-container>
          <v-container fluid class="text-center">
            <ul>
              <li>
                <div style="margin-top: 3px">
                  <i
                    class="icon mdi mdi-chevron-down-circle-outline pr-2"
                    style=""
                  ></i>
                  Dekker innbo for inntil 2 millioner
                </div>
              </li>
              <li>
                <div style="margin-top: 3px">
                  <i
                    class="icon mdi mdi-chevron-down-circle-outline pr-2"
                    style=""
                  ></i>
                  Inkludert eiendeler du tar med deg utenfor hjemmet
                </div>
              </li>
              <li>
                <div style="margin-top: 3px">
                  <i
                    class="icon mdi mdi-chevron-down-circle-outline pr-2"
                    style=""
                  ></i
                  >Tyveri, innbrudd, brann, skade, tap
                </div>
              </li>
              <li>
                <div style="margin-top: 3px">
                  <i class="icon mdi mdi-chevron-down-circle-outline pr-2"></i
                  >Flytting
                </div>
              </li>
              <li>
                <div style="margin-top: 3px">
                  <i
                    class="icon mdi mdi-chevron-down-circle-outline pr-2"
                    style=""
                  ></i
                  >Uflaks
                </div>
              </li>
              <li>
                <div style="margin-top: 3px">
                  <i
                    class="icon mdi mdi-chevron-down-circle-outline pr-2"
                    style=""
                  ></i
                  >Månedspris kr 179,-
                </div>
              </li>
            </ul>
            <div class="mt-4" style="font-size: 16pt;">
              <v-checkbox
                v-model="stepValues.bool.insuranceOrdered.value"
                label="Ja takk, jeg vil kjøpe super innboforsikring for 179 kr pr måned"
                color="success"
                :value="1"
                hide-details
              ></v-checkbox>
            </div>
          </v-container>
        </v-card-text>
      </v-card>
      </v-layout>
    </v-flex>
    <StepButtons @next-page="next" @previous-page="previous" :step="this" />
  </div>
</template>

<script>
import step from "../../mixins/step";
export default {
  mixins: [step],
  components: {},
  mounted: function () {},
};
</script>


<style scoped>
ul {
  list-style: none;
  padding: 0;
  font-size: 12pt;
}
li {
  color: #618849;
  width: 100%;
  display: block;
}
li i {
  display: inline-block;
  font-size: 14pt;
}
li div {
  text-align: left;
}

>>>.v-input--selection-controls.v-input .v-label {
    font-size: 12pt;
    font-weight: bold;
    color: #000;
}
</style>